<template>
  <div class="bju-v4">
    <div
      v-if="bju.b"
      class="bju-v4__item"
    >
      {{ bju.b }} <span>Б</span>
    </div>
    <div
      v-if="bju.j"
      class="bju-v4__item"
    >
      {{ bju.j }} <span>Ж</span>
    </div>
    <div
      v-if="bju.u"
      class="bju-v4__item"
    >
      {{ bju.u }} <span>У</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bju: {
      type: Object,
      default: () => ({
        b: 0,
        j: 0,
        u: 0,
      }),
    },
  },
}
</script>

<style lang="scss">
.bju-v4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @include typography('b1', 'bold');
  line-height: .16rem;
  color: map-get($colors, 'black');
  &__item {
    &:not(:last-child) {
      margin-right: 0.08rem;
    }
    span {
      color: map-get($colors, 'grey_40');
    }
  }
}
</style>
